import { apiFetch } from '../api';
import { paramsPrefix } from '../../constants/constant';
export const getOrgType = (globalTypeCategoryID, globalTypeName, status) => {
  return apiFetch(
    `/GlobalType/Search?isActive=${status}&globalTypeCategoryID=${globalTypeCategoryID}&globalTypeName=${globalTypeName}`
  );
};

export const getOrgTypeCombo = (globalTypeCategoryID) => {
  return apiFetch(
    `/GlobalType/GetForCombo/?globalTypeCategoryID=${globalTypeCategoryID}&includeSelect=false`
  );
};

export const saveOrgTypeAPI = (payload) => {
  return apiFetch(`/GlobalType/Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteOrgTypeAPI = (globalTypeID, globalTypeCategoryID) => {
  return apiFetch(
    `/GlobalType/Delete?globalTypeID=${globalTypeID}&globalTypeCategoryID=${globalTypeCategoryID}`,
    {
      method: 'POST'
    }
  );
};

export const getUserList = (status) => {
  return apiFetch(`/User/Search?isActive=${status}`);
};

export const getUserListCombo = () => {
  return apiFetch(`/User/getForCombo`);
};

export const saveUserAPI = (payload, viaDocterScreen = false) => {
  return apiFetch(`/User/Write/?viaDocterScreen=${viaDocterScreen}`, {
    method: 'POST',
    body: JSON.stringify({ ...payload })
  });
};

export const changePasswordAPI = (payload) => {
  return apiFetch(`/User/UpdatePassword`, {
    method: 'POST',
    body: JSON.stringify({ ...payload })
  });
};


export const deleteUserAPI = (userGUID) => {
  return apiFetch(`/User/Delete?id=${userGUID}`, {
    method: 'POST'
  });
};

export const getCityList = (statusGUID) => {
  return apiFetch(`/City/Search?isActive=${statusGUID}`);
};

export const getCityListCombo = () => {
  return apiFetch(`/City/GetForCombo?includeSelect=false`);
};

export const saveCityAPI = (payload) => {
  return apiFetch(`/City/${paramsPrefix}Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteCityAPI = (cityGUID) => {
  return apiFetch(`/City/${paramsPrefix}Delete?cityGUID=${cityGUID}`, {
    method: 'POST'
  });
};

export const getAreaList = (statusGUID) => {
  return apiFetch(`/Area/Search?isActive=${statusGUID}`);
};

export const getAreaListCombo = () => {
  return apiFetch(`/Area/GetForCombo?includeSelect=false`);
};

export const saveAreaAPI = (payload) => {
  return apiFetch(`/Area/${paramsPrefix}Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteAreaAPI = (AreaGUID) => {
  return apiFetch(`/Area/${paramsPrefix}Delete?AreaGUID=${AreaGUID}`, {
    method: 'POST'
  });
};

export const getSoftwareNameList = (statusGUID) => {
  return apiFetch(`/SoftwareName/Search?isActive=${statusGUID}`);
};

export const getSoftwareNameCombo = () => {
  return apiFetch(`/SoftwareName/GetForCombo?includeSelect=false`);
};

export const saveSoftwareNameAPI = (payload) => {
  return apiFetch(`/SoftwareName/Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteSoftwareNameAPI = (softwareNameGUID) => {
  return apiFetch(`/SoftwareName/Delete?softwareNameGUID=${softwareNameGUID}`, {
    method: 'POST'
  });
};
